import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { CaregiverState } from './states'

const Caregiver: Module<CaregiverState, State> = {
  state: new CaregiverState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default Caregiver
